import axios from "axios";
import showAlert from "../shared/alert";
import { msgTypes } from "../../constants/msgTypes";
import { LocalStorageService } from "../auth/LocalStorageService";
import { AuthService } from "../auth/AuthService";
import { ResponseModel } from "../../model/utilModels/ResponseModel";

const axiosEncrypted = axios.create({});

// Request interceptor: Add token
axiosEncrypted.interceptors.request.use(async (config) => {
  const token = await LocalStorageService.getToken();
  if (token && token !== "null") {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor: Decrypt + handle alerts + session expiry
axiosEncrypted.interceptors.response.use(
  async (response) => {
    let responseValue = new ResponseModel();
    try {
      const decrypted = await AuthService.getDecryptText(
        JSON.parse(response.data)
      );
      responseValue = JSON.parse(decrypted);
      if (responseValue.statusMsg === msgTypes.SUCCESS.msg) {
        return response;
      } else {
        // ❗️Server returned an error
        showAlert(
          responseValue.statusMsg || msgTypes.error,
          responseValue.statusRemark || msgTypes.SOMETHING_WENT_WRONG,
          msgTypes.error,
          msgTypes.OK_KEY
        );
        return Promise.reject(responseValue); // ⬅ return decrypted error
      }
    } catch (error: any) {
      if (error.response?.status === 401) {
        localStorage.clear();
        const isOnLoginPage = window.location.pathname === "/";
        if (!isOnLoginPage) {
          window.location.href = "/";
        }
      }

      showAlert(
        msgTypes.error,
        responseValue.statusRemark || msgTypes.SOMETHING_WENT_WRONG,
        msgTypes.error,
        msgTypes.OK_KEY
      );
      return Promise.reject(error);
    }
  },
  (error) => {
    console.error("Response error:", error?.response?.data);

    const isUnauthorized = error.response?.status === 401;
    const isOnLoginPage = window.location.pathname === "/";

    if (isUnauthorized) {
      localStorage.clear();
      if (!isOnLoginPage) {
        window.location.href = "/";
      }
    }

    // Handle encrypted error message from server
    (async () => {
      try {
        if (error.response?.data) {
          const decrypted = await AuthService.getDecryptText(
            JSON.parse(error.response.data)
          );
          const responseValue = JSON.parse(decrypted);
          if (responseValue.displayAlert) {
            showAlert(
              responseValue.statusMsg || msgTypes.error,
              responseValue.statusRemark || msgTypes.SOMETHING_WENT_WRONG,
              msgTypes.error,
              msgTypes.OK_KEY
            );
          }
        } else {
          showAlert(
            msgTypes.error,
            error?.message || msgTypes.SOMETHING_WENT_WRONG,
            msgTypes.error,
            msgTypes.OK_KEY
          );
        }
      } catch (decryptionError) {
        // fallback if decryption fails
        showAlert(
          msgTypes.error,
          error?.message || msgTypes.SOMETHING_WENT_WRONG,
          msgTypes.error,
          msgTypes.OK_KEY
        );
      }
    })();

    return Promise.reject(error);
  }
);

export default axiosEncrypted;
